import { User } from 'projects/core/src/lib/login/data/user';

// Move to own class file
export class UserProfile {
	shortName: string;
	color: string;
}

// TODO
export function getUserAvatar(user: User): UserProfile {
	const userProfile = new UserProfile();
	userProfile.shortName = '';
	userProfile.color = '';

	const splittedName = user.name.split(' ');

	if (splittedName.length < 2) {
		userProfile.shortName = userProfile.shortName.concat(splittedName[0][0])
		userProfile.color = userProfile.color.concat(splittedName[0][0].charCodeAt(0).toString())
		userProfile.color = userProfile.color.concat(splittedName[0][1].charCodeAt(0).toString())
	}

	else {
		userProfile.shortName = userProfile.shortName.concat(splittedName[0][0])
		userProfile.shortName = userProfile.shortName.concat(splittedName[1][0])
		userProfile.color = userProfile.color.concat(splittedName[0][0].charCodeAt(0).toString())
		userProfile.color = userProfile.color.concat(splittedName[1][0].charCodeAt(0).toString())
	}

	userProfile.color = userProfile.color.concat('10')

	return userProfile;
}
